const translations = {
  en: {
    brand: 'ElectionWeb',
    login: 'Login',
  },
  mr: {
    brand: 'ElectionWeb',
    login: 'लॉगिन',
  },
};

export default translations;
